import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLogoSas = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 27,
	viewBox: "0 0 27 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("filter", {
		id: "saturate",
		filterUnits: "objectBoundingBox",
		children: /* @__PURE__ */ _jsx("feColorMatrix", {
			type: "saturate",
			in: "SourceGraphic",
			values: .2
		})
	}), /* @__PURE__ */ _jsx("path", {
		d: "M13.928 0.0037862C12.5486 -0.0274045 11.1236 0.133819 9.66425 0.498476C2.91575 2.18419 -4.63839 10.8653 3.6102 20.875L8.53354 26.8348L9.92338 28.5309C10.8562 29.6399 12.3827 29.6201 13.504 28.6958C14.6309 27.7667 14.9513 26.2431 14.0222 25.1152C14.021 25.1136 13.6283 24.6382 13.4569 24.432H13.4804C13.1246 24.0039 13.0473 23.9321 12.6795 23.4898C10.8977 21.3468 8.86333 18.8727 8.86333 18.8727C5.28178 14.526 6.87986 9.15601 11.7372 6.10496C16.017 3.41667 23.8708 4.37684 26.5779 8.79041C24.8729 3.75818 19.9054 0.138946 13.928 0.0037862ZM14.9174 10.51C14.281 10.4884 13.6166 10.731 13.0564 11.1932C11.9276 12.1232 11.61 13.6487 12.5382 14.7738C12.54 14.7766 12.6522 14.9161 12.8444 15.1507C14.9795 17.7159 17.8149 21.1576 17.8149 21.1576C21.3973 25.5043 19.7983 30.8507 14.9409 33.9018C10.6621 36.5891 2.80739 35.6271 0.100259 31.2163C2.19868 37.407 9.23176 41.454 17.0139 39.5083C23.7643 37.8197 31.3166 29.1631 23.068 19.1553L17.2966 12.1826L16.637 11.3581C16.1706 10.8036 15.5538 10.5317 14.9174 10.51Z",
		fill: "#007CC2",
		filter: "url(#saturate)"
	})]
});
export default SvgLogoSas;
